export const COMMENTS = {
  COMMENT_LIST: 'COMMENT_LIST',
};
